"use strict";
// @ts-expect-error required syntax for MFE
import('./bootstrap.tsx');
